//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import screenfull from 'screenfull';
import cockpit from "./com/cockpit";
import siteInfo from "./com/siteInfo";
import villageInfo from "./com/villageInfo";
import wasteBlackInfo from "./com/wasteBlackInfo";
import wasteWaterInfo from "./com/wasteWaterInfo";
export default {
  data: function data() {
    return {
      tabId: 1,
      isFullscreen: false,
      tabActive: '1'
    };
  },
  components: {
    cockpit: cockpit,
    siteInfo: siteInfo,
    villageInfo: villageInfo,
    wasteBlackInfo: wasteBlackInfo,
    wasteWaterInfo: wasteWaterInfo
  },
  methods: {
    changeTab: function changeTab(tab, type) {
      this.tabId = tab;
      this.selectedSiteType = type;
    },
    fullscreen: function fullscreen() {
      screenfull.toggle();
      this.isFullscreen = !this.isFullscreen;
    },
    goHome: function goHome() {
      this.$router.push('/monitor/map');
    },
    toTab: function toTab(tab) {
      this.tabActive = tab;
    }
  }
};